import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class LeaveRequestAction  {
    _originalTypeClassName = "zERP.BO.LeaveRequestAction";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
LeaveRequestAction.translate = translateService;
}
this.Id = null;
this.ExecutedOn = null;
this.Notes = null;
this.ActionType = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ExecutedOn:any;
Notes:any;
ActionType:any;
ExecutedBy:any;
LeaveRequest:any;
static setExecutedBy = ($this, value) => {
var oldValue = $this.ExecutedBy;
$this.ExecutedBy = value;
if (value != null) {
}
}
static setLeaveRequest = ($this, value) => {
var oldValue = $this.LeaveRequest;
$this.LeaveRequest = value;
if (value != null) {
if (oldValue != null) {
Domain.EmployeeLeaveRequest.removeActions(oldValue, $this);
}
Domain.EmployeeLeaveRequest.addActions(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}